export const FallbackCoverId = 'mrunjkqldk6ojyfxjvj1'

export enum Role {
  Admin = 'admin',
  User = 'user',
}

export interface Parcel {
  id: number
  length: string | null
  width: string | null
  height: string | null
  weight: string | null
  expanded: boolean
}

export interface Order {
  id: number
  uid: string
  trackingNumbers: string[]
  labels: string[]
  senderAddress: Address
  recipientAddress: Address
  status: string
  provider: string
  subtotal: number
  tax: number
  fuel: number
  total: number
  parcels: Parcel[]
  pickupPoint: PickupPoint | string
  createdAt: string
  updatedAt: string
  user: User
}

export interface CreditTransaction {
  id: number
  userId: number
  amount: number
  type: string
  note: string
  createdAt: string
  user: User
  order: Order

  invoiceUrl: string | null
  invoice: Invoice | null

  weight: number
  subtotal: number
  total: number
  fuel: number
  tax: number
}

export type Paginator<T> = {
  data: T[]
  meta: {
    total: number
    last_page: number
    current_page: number
  }
}

export interface PickupPoint {
  id: string
  name: string
  isActive: boolean
}

// DropoffPoint是PickupPoint的一个别名，保持前后端命名一致性
export type DropoffPoint = PickupPoint

export type Credentials = {
  email: string
  password: string
  firstName?: string
  lastName?: string
  phone?: string
  companyName?: string
}

export interface Provider {
  id: number
  name: string
  code: string
  logo: string
  description?: string
  fuelRate?: number
  settings?: Record<string, any>
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface Country {
  id: number
  name: string
  code: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface ProviderCountryPricing {
  id: number
  countryId: number
  providerId: number
  deliveryDays: string
  prices: {
    id: number
    minWeight: number
    maxWeight: number
    price: number
  }[]
}

export type User = {
  id: number
  email: string
  firstName: string
  lastName: string
  password?: string
  role: Role
  wechatId: string
  raisonSociale: string
  siren: string
  tva: string
  iban: string
  swift: string
  address: string
  zipCode: string
  city: string
  country: string
  phone: string
  companyName: string
  creditBalance: number
  creditLimit: number
}

export type Address = {
  id: number
  title: string
  firstName?: string
  lastName?: string
  street: string
  city: string
  zipCode: string
  country: string
  phone?: string
  email?: string
  additionalInfo?: string
  displayAddress: string
  countryCode: string
  isDefault: boolean
  type: 'sender' | 'recipient'
  name?: string
}

export type Option = {
  value: string | number
  label: string
}

export interface Invoice {
  id: number
  invoiceNumber: string
  userId: number
  user?: {
    id: number
    first_name: string
    last_name: string
    email: string
    company_name: string
  }
  totalAmount?: number
  tvaAmount?: number
  startDate: string
  endDate: string
  status: 'pending' | 'paid' | 'failed'
  paidAt: string | null
  createdAt: string
  storagePath: string
}
